export const registerServiceWorker = () => {
    if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
        return;
    }

    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').catch((error) => {
            console.error('Не удалось зарегистрировать service worker:', error);
        });
    });
};
